(function () {
  const aliases = {'日本':'Japan','东京':'Tokyo','東京':'Tokyo','京都':'Kyoto','大阪':'Osaka','北海道':'Hokkaido','富士山':'Mount Fuji','韩国':'Korea','韓國':'Korea','首尔':'Seoul','首爾':'Seoul','釜山':'Busan','济州':'Jeju','濟州':'Jeju','中国':'China','中國':'China','北京':'Beijing','上海':'Shanghai','成都':'Chengdu','西安':'Xian','马来西亚':'Malaysia','馬來西亞':'Malaysia','吉隆坡':'Kuala Lumpur','槟城':'Penang','檳城':'Penang','新加坡':'Singapore','泰国':'Thailand','泰國':'Thailand','曼谷':'Bangkok','清迈':'Chiang Mai','清邁':'Chiang Mai','普吉岛':'Phuket','普吉島':'Phuket','越南':'Vietnam','河内':'Hanoi','河內':'Hanoi','岘港':'Da Nang','峴港':'Da Nang','欧洲':'Europe','歐洲':'Europe','美洲':'Americas'};

  function init() {
    const input = document.getElementById('leda-destination-search');
    if (!input || input.dataset.ledaSearchReady === 'true') return;
    input.dataset.ledaSearchReady = 'true';
    const form = document.querySelector('[data-destination-search-form]');
    const results = document.querySelector('[data-product-results]');
    const grid = document.querySelector('[data-product-grid]');
    const loading = document.querySelector('[data-product-loading]');
    const empty = document.querySelector('[data-product-empty]');
    const count = document.querySelector('[data-product-results-count]');
    const title = document.querySelector('[data-product-results-title]');
    const status = document.querySelector('[data-search-status]');
    const customLink = document.querySelector('[data-product-custom-link]');
    const clearButton = document.querySelector('[data-clear-destination-search]');
    const isChinese = document.documentElement.lang.toLowerCase().startsWith('zh');
    let timer;
    let controller;

    function make(tag, className, text) {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (text !== undefined) element.textContent = text;
      return element;
    }

    function renderProduct(product) {
      const link = make('a', 'leda-product-card');
      link.href = product.url;
      const media = make('div', 'leda-product-card__media');
      if (product.featured_image && product.featured_image.url) {
        const image = document.createElement('img');
        image.src = product.featured_image.url;
        image.alt = product.featured_image.alt || product.title;
        image.loading = 'lazy';
        media.appendChild(image);
      } else {
        media.appendChild(make('span', '', 'LEDA TRIP'));
      }
      link.appendChild(media);
      const body = make('div', 'leda-product-card__body');
      body.appendChild(make('small', '', isChinese ? '私家团' : 'PRIVATE TOUR'));
      body.appendChild(make('h3', '', product.title));
      const footer = make('div', 'leda-product-card__foot');
      if (product.price) footer.appendChild(make('span', '', product.price));
      footer.appendChild(make('b', '', isChinese ? '查看行程 →' : 'View tour →'));
      body.appendChild(footer);
      link.appendChild(body);
      return link;
    }

    function reset() {
      if (controller) controller.abort();
      results.hidden = true;
      grid.replaceChildren();
      status.textContent = '';
    }

    async function search(shouldScroll) {
      const raw = input.value.trim();
      if (raw.length < 2) { reset(); return; }
      const query = aliases[raw] || raw;
      results.hidden = false;
      loading.hidden = false;
      empty.hidden = true;
      grid.replaceChildren();
      title.textContent = '“' + raw + '”';
      count.textContent = '';
      status.textContent = isChinese ? '正在搜索产品…' : 'Searching tours…';
      customLink.href = '/pages/tailor-made-tour?destination=' + encodeURIComponent(raw);
      if (shouldScroll) results.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (controller) controller.abort();
      controller = new AbortController();
      try {
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const url = root + 'search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title,vendor,body,tag';
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) throw new Error('Search request failed');
        const data = await response.json();
        const products = data.resources.results.products || [];
        products.forEach((product) => grid.appendChild(renderProduct(product)));
        loading.hidden = true;
        empty.hidden = products.length > 0;
        count.textContent = isChinese ? products.length + ' 个私家团' : products.length + ' private tour' + (products.length === 1 ? '' : 's');
        status.textContent = count.textContent;
      } catch (error) {
        if (error.name === 'AbortError') return;
        loading.hidden = true;
        empty.hidden = false;
        status.textContent = isChinese ? '暂时无法载入搜索结果' : 'Unable to load results. Please try again.';
      }
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(() => search(false), 400);
    });
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      clearTimeout(timer);
      search(true);
    });
    clearButton.addEventListener('click', function () {
      input.value = '';
      reset();
      input.focus();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
